import React, { useState, useEffect, useCallback, useRef } from 'react';
import WriteMode from './WriteMode';
import styled from 'styled-components';
import ReactDOM from 'react-dom';
import { checkSession } from '../../../../Common/Utils/SsoSession';

const BoardWrapper = styled.div`
  background: ${({ theme }) => theme.colors.neutral[0]};

  table {
    width: 100%;
    border-spacing: 0;
    border-radius: ${({ theme }) => theme.borderRadius.base};
    overflow: hidden;
    box-shadow: ${({ theme }) => theme.elevation.base};
  }

  .WriteButton {
    margin-top: ${({ theme }) => theme.spacing[4]};
    padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[4]}`};
    background: ${({ theme }) => theme.colors.primary[500]};
    color: ${({ theme }) => theme.colors.neutral[0]};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.base};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    cursor: pointer;
    transition: background ${({ theme }) => theme.transition.fast};

    &:hover {
      background: ${({ theme }) => theme.colors.primary[700]};
    }
  }

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing[1]};
    margin: ${({ theme }) => theme.spacing[8]} 0;

    a {
      padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
      border-radius: ${({ theme }) => theme.borderRadius.base};
      border: 1px solid ${({ theme }) => theme.colors.neutral[200]};
      background: ${({ theme }) => theme.colors.neutral[0]};
      color: ${({ theme }) => theme.colors.neutral[700]};
      cursor: pointer;
      transition: background ${({ theme }) => theme.transition.fast};

      &:hover {
        background: ${({ theme }) => theme.colors.neutral[100]};
      }
    }

    label {
      cursor: pointer;
    }
  }

  .QA_게시판 {
    thead {
      background: ${({ theme }) => theme.colors.neutral[100]};
    }

    th, td {
      padding: ${({ theme }) => theme.spacing[4]};
      border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[200]};
    }

    th {
      font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
      color: ${({ theme }) => theme.colors.neutral[700]};
      font-size: ${({ theme }) => theme.typography.fontSize.sm};
    }

    tbody tr:hover {
      background: ${({ theme }) => theme.colors.neutral[50]};
    }

    a, button {
      color: ${({ theme }) => theme.colors.primary[500]};
      cursor: pointer;
      &:hover { color: ${({ theme }) => theme.colors.primary[700]}; }
    }
  }

  .Contents_Active {
    background: ${({ theme }) => theme.colors.neutral[0]};
    border-radius: ${({ theme }) => theme.borderRadius.base};
    box-shadow: ${({ theme }) => theme.elevation.base};
    margin: ${({ theme }) => theme.spacing[4]} 0;
    padding: ${({ theme }) => theme.spacing[5]};
    overflow: hidden;
  }

  .Contents_Deactive {
    display: none;
  }
`;

const Contents_View = ({
 subject,
 commentList,
 onRefreshComments,
 onRefreshPosts,
 onDeleteComment,
 onInsertComment,
 session
}) => {
 const [commentText, setCommentText] = useState('');
 const commentRef = useRef(null);

 const isOwner = session?.Name === subject?.notice_name;

 const handleClose = () => {
   if (onRefreshPosts) onRefreshPosts();
 };

 const handleEditPost = () => {
   if (!subject) return;
   ReactDOM.render(
     <WriteMode Refrash={onRefreshPosts} Data={subject} />,
     document.getElementById('Board_Contents')
   );
 };

 const handleInsertComment = async () => {
   if (!commentText.trim()) return;
   
   await onInsertComment(commentText);
   if (commentRef.current) {
     commentRef.current.value = '';
   }
   setCommentText('');
 };

 return (
   <div style={{ padding: '10px' }}>
     {subject && (
       <div
         style={{
           display: 'flex',
           justifyContent: 'space-between',
           background: '#f0f0f0',
           padding: '10px',
           borderRadius: '4px'
         }}
       >
         <div>
           <b>작성자:</b> {subject.notice_name}{' '}
           <b style={{ marginLeft: 20 }}>조회수:</b> {subject.search_count}
         </div>
         <div>
           {isOwner && (
             <>
               <button style={{ marginRight: 5 }} onClick={handleEditPost}>
                 수정
               </button>
               <button style={{ marginRight: 5 }} onClick={() => onRefreshPosts()}>
                 삭제
               </button>
             </>
           )}
           <button onClick={handleClose}>닫기</button>
         </div>
       </div>
     )}

     {subject && (
       <div style={{ margin: '10px 0' }}>
         <div dangerouslySetInnerHTML={{ __html: subject.notice_contents }} />
       </div>
     )}

     {subject && (
       <div className="CommentBox" style={{ marginTop: 20 }}>
         <h3>댓글 : {commentList?.length || 0}개</h3>
         <hr />
         <div className="댓글_목록">
           {commentList?.map((comment, i) => (
             <div key={i} style={{ marginBottom: 10 }}>
               <li className="댓글_li">
                 <b>{comment.user_name}</b>
                 <div className="댓글_div">
                   <div>
                     {comment.contents}
                     <div className="댓글_시간_div">
                       {comment.create_time}
                     </div>
                   </div>
                   {session?.UserId === comment.user_id && (
                     <button
                       className="댓글삭제_버튼"
                       onClick={() => onDeleteComment(comment)}
                     >
                       삭제
                     </button>
                   )}
                 </div>
               </li>
               <hr color="#D8D8D8" size="1" />
             </div>
           ))}

           {session?.UserId ? (
             <div className="댓글_div">
               <textarea
                 className="댓글_textarea"
                 ref={commentRef}
                 rows={2}
                 onChange={(e) => setCommentText(e.target.value)}
                 placeholder="댓글을 입력하세요"
               />
               <button 
                 className="댓글쓰기_버튼" 
                 onClick={handleInsertComment}
                 disabled={!commentText.trim()}
               >
                 등록
               </button>
             </div>
           ) : (
             <div style={{ color: 'red' }}>
               로그인을 해야 댓글 작성이 가능합니다.
             </div>
           )}
         </div>
       </div>
     )}
   </div>
 );
};

function DeveloperBoard({ 
 apiFetchPage,
 apiFetchPageList,
 apiReadNews,
 apiReadComments,
 apiIncreaseCount,
 apiDeleteNews,
 apiDeleteComment,
 apiInsertComment,
 selectedCategory,
 onCategoryChange,
 boardType,
 args,
 setBoardType,
 setNum,
 data
}) {
 const [posts, setPosts] = useState([]);
 const [pageInfo, setPageInfo] = useState({
   currentPage: 0,
   selectedPage: 1,
   pageList: [],
   hasNext: false,
   minRange: 0,
   maxRange: 0
 });
 const [currentContent, setCurrentContent] = useState(null);
 const [session, setSession] = useState({});
 const [isPublic, setIsPublic] = useState(true);
 const [isContentOpen, setIsContentOpen] = useState(false);
 useEffect(() => {
  setCurrentContent(null);
  setIsContentOpen(false);
  if (contentsDivRef.current) {
    contentsDivRef.current.className = 'Contents_Deactive';
  }
}, [boardType]); // boardType이 변경될 때마다 실행
 const contentsDivRef = useRef(null);

 useEffect(() => {
   setIsContentOpen(!!currentContent);
 }, [currentContent]);

 const createSession = useCallback(async () => {
   try {
     const data = await checkSession();
     setSession(data);
   } catch (err) {
     console.error('Session creation failed:', err);
   }
 }, []);
// fetchPosts 수정
const fetchPosts = useCallback(async (min, max) => {
  if (!apiFetchPage) return;
  try {
    const response = await fetch(apiFetchPage, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        MinNumber: min,
        MaxNumber: max,
        IsPublic: isPublic,
        Category: selectedCategory
      })
    });
    if (!response.ok) return;
    const text = await response.text();
    if (!text) return;
    const data = JSON.parse(text);
    setPosts(Array.isArray(data) ? data : []);
    setPageInfo(prev => ({
      ...prev,
      minRange: min,
      maxRange: max
    }));
  } catch (err) {
    console.error('Failed to fetch posts:', err);
  }
}, [apiFetchPage, selectedCategory, isPublic]);

 const fetchPageList = useCallback(async () => {
   if (!apiFetchPageList) return;

   try {
     const response = await fetch(apiFetchPageList, {
       method: 'POST',
       mode: 'cors',
       credentials: 'include',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify({
         IsPublic: isPublic,
         Category: selectedCategory
       })
     });
     if (!response.ok) return;
     const text = await response.text();
     if (!text) return;
     const info = JSON.parse(text);
     if (!Array.isArray(info) || !info.length) return;

     const pageCount = [];
     const totalPages = info[0].totalpage + 1;
     const { currentPage } = pageInfo;

     for (let i = 0; i < totalPages; i++) {
       if (i + 1 > (currentPage * 10) && i < ((currentPage + 1) * 10)) {
         pageCount.push(i + 1);
       }
     }

     const hasNext = pageCount[pageCount.length - 1] === totalPages && 
                    (info[0].itemcount > (currentPage + 1) * 10) * 10;

     setPageInfo(prev => ({
       ...prev,
       pageList: pageCount,
       hasNext
     }));
   } catch (err) {
     console.error('Failed to fetch page list:', err);
   }
 }, [apiFetchPageList, selectedCategory, isPublic, pageInfo.currentPage]);

 const handleReadContent = useCallback(async (post) => {
   if (!apiReadNews || !apiReadComments || !apiIncreaseCount) return;
 
   try {
     if (currentContent && currentContent.num === post.num) {
       setCurrentContent(null);
       return;
     }
 
     const response = await fetch(apiReadNews, {
       method: 'POST',
       mode: 'cors',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(post)
     });
     if (!response.ok) return;
     const dataText = await response.text();
     if (!dataText) return;
     const data = JSON.parse(dataText);
     if (!Array.isArray(data) || !data.length) return;
 
     const commentsResponse = await fetch(apiReadComments, {
       method: 'POST',
       mode: 'cors',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(data[0])
     });
     const comments = commentsResponse.ok ? await commentsResponse.json() : [];
 
     await fetch(apiIncreaseCount, {
       method: 'POST',
       mode: 'cors',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(post)
     });
 
     setCurrentContent({ ...data[0], CommentData: comments });
 
   } catch (err) {
     console.error('Failed to read content:', err);
   }
 }, [apiReadNews, apiReadComments, apiIncreaseCount, currentContent?.num]);

 const handleDeletePost = useCallback(async (post) => {
   if (!apiDeleteNews) return;

   try {
     await fetch(apiDeleteNews, {
       method: 'POST',
       mode: 'cors',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(post)
     });
     fetchPosts(pageInfo.minRange, pageInfo.maxRange);
   } catch (err) {
     console.error('Failed to delete post:', err);
   }
 }, [apiDeleteNews, pageInfo.minRange, pageInfo.maxRange, fetchPosts]);

 const handleDeleteComment = useCallback(async (comment) => {
   if (!apiDeleteComment) return;

   try {
     await fetch(apiDeleteComment, {
       method: 'POST',
       mode: 'cors',
       credentials: 'include',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(comment)
     });
     if (currentContent) {
       handleReadContent(currentContent);
     }
   } catch (err) {
     console.error('Failed to delete comment:', err);
   }
 }, [apiDeleteComment, currentContent, handleReadContent]);

 const handleInsertComment = useCallback(async (commentText) => {
   if (!apiInsertComment || !currentContent) return;

   try {
     await fetch(apiInsertComment, {
       method: 'POST',
       mode: 'cors',
       credentials: 'include',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify({
         noticeNum: currentContent.num,
         commentText
       })
     });
     handleReadContent(currentContent);
   } catch (err) {
     console.error('Failed to insert comment:', err);
   }
 }, [apiInsertComment, currentContent, handleReadContent]);

 const handleWriteMode = () => {
   setCurrentContent({});
   if (contentsDivRef.current) {
     contentsDivRef.current.className = 
       contentsDivRef.current.className === 'Contents_Deactive' 
         ? 'Contents_Active' 
         : contentsDivRef.current.className;
   }
 };

 // 초기 마운트와 주요 데이터 변경 시
// useEffect 수정
useEffect(() => {
  createSession();
  // 초기 로딩 시에만 페이지 리스트 업데이트
  fetchPosts(0, 10, true);

  if (args) {
    args((value) => {
      setIsPublic(value);
      fetchPosts(0, 10, true);
    });
  }

  if (data?.num) {
    handleReadContent({ num: data.num });
  }
}, [createSession, fetchPosts, handleReadContent, args, data]);


 // 카테고리 변경 시 
 useEffect(() => {
  if (selectedCategory) {
    fetchPosts(pageInfo.minRange, pageInfo.maxRange);
  }
}, [selectedCategory]); // fetchPosts는 의존성에서 제외

 // 컴포넌트 언마운트 시
 useEffect(() => {
   return () => {
     setCurrentContent(null);
     setPosts([]);
     setPageInfo({
       currentPage: 0,
       selectedPage: 1,
       pageList: [],
       hasNext: false,
       minRange: 0,
       maxRange: 0
     });
   };
 }, []);

 const handlePageChange = useCallback(async (page) => {
   const min = page * 10 - 9;
   const max = page * 10;
   await fetchPosts(min, max);
   setPageInfo(prev => ({ ...prev, selectedPage: page }));
 }, [fetchPosts]);


 return (
    <BoardWrapper>
       <div 
      ref={contentsDivRef} 
      id="Board_Contents" 
      className={isContentOpen ? 'Contents_Active' : 'Contents_Deactive'}
    >
      {currentContent && (
        <Contents_View 
          subject={currentContent}
          commentList={currentContent.CommentData}
          onRefreshComments={() => handleReadContent(currentContent)}
          onRefreshPosts={() => fetchPosts(pageInfo.minRange, pageInfo.maxRange)}
          onDeleteComment={handleDeleteComment}
          onInsertComment={handleInsertComment}
          session={session}
        />
      )}
    </div>

      <table className="QA_게시판">
        <thead>
          <tr>
            <th width="8%">No</th>
            <th width="12%">작성자</th>
            <th width="12%">카테고리</th>
            <th width="55%">내용</th>
            <th width="8%">조회수</th>
            {session.UserId === 'dexterity' && <th width="5%">삭제</th>}
          </tr>
        </thead>
        <tbody>
          {posts.map((post, i) => (
            <tr style={{ height: '40px' }} key={i}>
              <td><div align="center">{post.num}</div></td>
              <td><div align="center">{post.notice_name}</div></td>
              <td><div align="center">{post.notice_category}</div></td>
              <td>
                <a onClick={() => handleReadContent(post)}>
                  {post.notice_title}
                </a>
              </td>
              <td><div align="center">{post.search_count}</div></td>
              {session.UserId === 'dexterity' && (
                <td width="45px">
                  <button onClick={() => handleDeletePost(post)}>삭제</button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        {pageInfo.pageList.map((page, index) => (
          <span key={index}>
            {index === 0 && page > 1 && (
              <a onClick={() => {
                setPageInfo(prev => ({ ...prev, currentPage: prev.currentPage - 1 }));
                fetchPageList();
              }}>[이전]</a>
            )}
            <a onClick={() => handlePageChange(page)}>
              <label style={{
                color: pageInfo.selectedPage === page ? 'red' : 'black',
                margin: '5px',
                cursor: 'pointer'
              }}>[{page}]</label>
            </a>
            {index === 9 && !pageInfo.hasNext && (
              <a onClick={() => {
                setPageInfo(prev => ({ ...prev, currentPage: prev.currentPage + 1 }));
                fetchPageList();
              }}>[다음]</a>
            )}
          </span>
        ))}
      </div>

      <button 
        disabled={!session.UserId} 
        className="WriteButton"
        onClick={handleWriteMode}
      >
        신규 글쓰기
      </button>
    </BoardWrapper>
  );
}

export default DeveloperBoard;